import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";
import { post } from "@common/api/apiShared";
import { useTranslation } from "@localization/useTranslation";

// The endpoint segment matches the value exactly: POST /risk-assessments/{id}/retire | /reinstate.
export type RiskAssessmentLifecycleAction = "retire" | "reinstate";

export function useRetireRiskAssessmentDialog(riskAssessmentId: string, action: RiskAssessmentLifecycleAction, onSaved: () => void) {
    const { translateString } = useTranslation();
    const snackbar = useDotLegalSnackbar();

    const mutation = useDotLegalMutation((reason: string) => post(`/risk-assessments/${riskAssessmentId}/${action}`, { reason }));

    const submit = (reason: string) =>
        mutation.mutateAsync(reason, {
            onSuccess: () => {
                snackbar.show(translateString(action === "retire" ? "riskAssessmentRetired" : "riskAssessmentReinstated"));
                onSaved();
            },
        });

    return { inProgress: mutation.isLoading, submit };
}
